import { render, staticRenderFns } from "./IdeasPage.vue?vue&type=template&id=4750c5be&"
import script from "./IdeasPage.vue?vue&type=script&lang=js&"
export * from "./IdeasPage.vue?vue&type=script&lang=js&"
import style0 from "./IdeasPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports